module.exports = __webpack_public_path__ + "img/american-express-logo.a0086b9e.svg";